import ContrAgentService from "../services/contragent.service";

const contragentInitial = {
	
	id: null,
	fullName: '',
	shortName: '',
	email: '',
	phone: '',
	mobile: '',
	address: '',
	inn: null,
	okonx: null,
	address2: '',
	countryId: null,
	countryName: '',
	categoryId: null,
	categoryName: '',
	groupId: null,
	groupName: '',
	comment: '',
};
const state = {
	// Contragent orders uchun
	pageStoreForContragent:1,
	selectedStoreForContragent: 'working',

	pageStore:1,
	selectedStore: 'working',
	//end
	regions : [],
	requestItems : null,
	editRequest: false,
	ordersListManagerPage:[],
	totalOrderManagerPage: 0,
	ordersList:[],
	totalOrder: 0,
	contragents: [],
	contragent: {},
	contragentsForPos: [],
	total: 0,
	paramsForFilter: {
		page: 1,
		limit: 200,
		contragentName: '',
		attributes: []
	},
	loadingForContragent: false,
	newContragent: null,
	currentContragentForTransfer: Object.assign({}, contragentInitial),
	currentDepartmentForMoneyTransfer: null,
	newMoneyTransfer: null,
	saldoByYear: null,
	moneyTransferError: false,
	moneyTransferErrorMessage: '',
	saldoByYearError: false,
	saldoByYearErrorMessage: '',
	notAllowedError: false,
	deleteContragentErrorMessage: '',
	createError: false,
	createContragentErrorMessage: '',
	contragentSaldo: '',
	contragentSaldoError: {
		boolean: false
	}
};

const getters = {
	contragents: (state) => {
		return state.contragents
	},
	contragent: (state) => {
		return state.contragent

	},
	getContragentsForPos: (state) => {
		return state.contragentsForPos;
	},
	total: (state) => {
		return state.total;
	},
	perPage: (state) => {
		return state.paramsForFilter.limit;
	}
}


const actions = {

	async getOrdersListForManager({commit}, payload) {
		try {
			let res;
			switch (payload.selected) {
				case 'new':
					res = await ContrAgentService.getOrdersListNewDocs(payload.search)
					break;
				case 'working':
					res = await ContrAgentService.getOrdersListOnProcess(payload.search)
					break;
				case 'finished':
					res = await ContrAgentService.getOrdersListArxiv(payload.search)
					break;
			}
			await commit('setOrdersListForManger', res.data)
		} catch (error) {
			return false
		}
	},

	async getOrdersList({commit}, payload) {
		try {
			let res;
			switch (payload.selected) {
				case 'new':
					res = await ContrAgentService.getOrdersListNewDocsForContragent(payload.search)
					break;
				case 'working':
					res = await ContrAgentService.getOrdersListOnProcessForContragentAccount(payload.search)
					break;
				case 'finished':
					res = await ContrAgentService.getOrdersListArxiv(payload.search)
					break;
			}
			await commit('setOrdersList', res.data)
		} catch (error) {
			return false
		}
	},
	async getConragentSaldo({commit}, payload){
		try {
			const res = await ContrAgentService.getConragentSaldo(payload)
			await commit('setContragentSaldo', res.data)
			await commit('setContragentSaldoError',{boolean: false})

		} catch (e) {
			await commit('setContragentSaldoError',{boolean: true})
			await commit('setContragentSaldo', '')
			return false
		}
	},
	async fetchContragents({commit}, fromComponentTxtOrDepartmentsList = '') {
		try {
			let newPayload = {};
			if (Array.isArray(fromComponentTxtOrDepartmentsList)) {
				if (fromComponentTxtOrDepartmentsList.length > 0) {
					newPayload.departmentIds = fromComponentTxtOrDepartmentsList.map(el => el.id);
				}
			}
			newPayload.page = state.paramsForFilter.page;
			newPayload.limit = state.paramsForFilter.limit;
			newPayload.contragentName = state.paramsForFilter.contragentName

			if (state.paramsForFilter.attributes.length > 0) {
				state.paramsForFilter.attributes.forEach(el => {
					if (el.field == 'category.id') {
						newPayload.categoryId = el.value;
					} else if(el.field == 'group.id') {
						newPayload.groupId = el.value;
					}
				})
			}
			if(state.regions.length> 0) {
				newPayload.regionIds = state.regions.map(el => el.id);
			}

			commit('setLoading', true);
			const contragents = await ContrAgentService.search(newPayload);
			commit('setLoading', false);
			if (fromComponentTxtOrDepartmentsList == 'pos') {
				commit('setContragentsForPos', contragents.data);
			} else {
				commit('setContragents', contragents.data);
			}
			return true
		} catch (e) {
			commit('setLoading', false);
			return false
		}
	},

	/* SET CURRENTPAGE */
	async setCurrentPage({commit}, currentPage) {
		await commit('setPage', currentPage);
	},
	/* FILTER ACTIONS BEGIN */
	async setParamForFilter({commit}, fieldObj) {
		await commit('setParam', fieldObj);
	},
	deleteParamFromFilter({commit}, fieldName) {
		commit('deleteParam', fieldName);
	},
	resetParamForFilter({commit}) {
		commit('resetParam');
	},
	/* FILTER ACTIONS END */

	async createContragentStore({commit}, newContragentData) {
		try {
			const addContragent = await ContrAgentService.storeOrUpdate(newContragentData);
			commit('newContragent', addContragent.data);
			return true
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('createContragentError', {message: response.message, boolean: true});
			return false
		}
	},
	async createSaldoMoneyTransfer({commit}, akt) {
		try {
			commit('setLoading', true);
			const response = await ContrAgentService.saldoMoneyTransfer(akt);
			commit('setLoading', false);
			commit('setSaldoMoneyTransferResponse', response.data);
			return true
		} catch (e) {
			commit('setLoading', false);
			let response = JSON.parse(e.request.response);
			commit('createMoneyTransferError', {message: response.message, boolean: true});
			return false
		}
	},
	async getSaldoList({commit}, payload) {
		try {
			commit('setLoading', true);
			const response = await ContrAgentService.getSaldoByYear(payload);
			commit('setLoading', false);
			commit('setSaldoByYear', response.data);
			return true
		} catch (e) {
			commit('setLoading', false);
			let response = JSON.parse(e.request.response);
			commit('setSaldoByYearError', {message: response.message, boolean: true});
			return false
		}
	},
	async deleteContragentStore({commit}, id) {
		try {
			const deleteResponse = await ContrAgentService.deleteContragent(id);
			commit('deleteContragent', {deleteResponse, id})
			return true;
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('deleteContragentError', {message: response.message, boolean: true});
			return false;
		}
	},

	async getContragentStoreById({commit}, contragentId) {
		try {
			const getContragentResponse = await ContrAgentService.getContragentById(contragentId);
			commit('setSingleContragent', getContragentResponse.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async setRegions({commit}, regions) {
		await commit('setRegions', regions)
	}
};

const mutations = {
	// contragent orders uchun
	setValuePageStore(state,paylaod) {
		state.pageStore = paylaod
	},
	setValueSelectedStore(state,paylaod) {
		state.selectedStore = paylaod
	},

	setValuePageStoreForContragent(state,paylaod) {
		state.pageStoreForContragent = paylaod
	},
	setValueSelectedStoreForContragent(state,paylaod) {
		state.selectedStoreForContragent = paylaod
	},
	// ?/end
	setContragentName(state, paylaod) {
		state.paramsForFilter.contragentName=paylaod
	},
	setRegions(state, payload) {
		state.regions = payload
	},
	setOrdersListForManger(state, paylaod) {
		state.ordersListManagerPage = paylaod.items
		state.totalOrderManagerPage = paylaod.total
	},
	setRequestItems(state, paylaod){
		state.requestItems = paylaod.data
		state.editRequest = paylaod.edit
	},
	setOrdersList(state, payload) {
		state.ordersList = payload.items
		state.totalOrder = payload.total
	},
	setContragentSaldoError(state, payload) {
		state.contragentSaldoError.boolean = payload.boolean;
	},
	setContragentSaldo(state, payload) {
		state.contragentSaldo = payload
	},
	setSingleContragent(state, payload) {
		state.contragent = payload
	},
	setLoading(state, boolean) {
		state.loadingForContragent = boolean;
	},
	setContragents(state, contragents) {
		state.contragents = contragents.items;
		state.total = contragents.total;
	},
	setContragentsForPos(state, contragents) {
		state.contragentsForPos = contragents.items;
	},
	setCurrentContragentForTransfer(state, payload) {
		if (payload) {
			state.currentContragentForTransfer = payload;
		} else {
			state.currentContragentForTransfer = Object.assign({}, contragentInitial);
		}
	},
	setCurrentDepartmentForMoneyTransfer(state, payload) {
		state.currentDepartmentForMoneyTransfer = payload;
	},
	/* SET CURRENTPAGE */
	setPage(state, page) {
		state.paramsForFilter.page = page;
	},
	/* FILTER MUTATIONS BEGIN */
	setParam(state, fieldObj) {
		state.paramsForFilter.attributes.push(fieldObj);
	},
	deleteParam(state, fieldName) {
		if (state.paramsForFilter.attributes.length > 0) {
			let indexToRemove = state.paramsForFilter.attributes.findIndex(el => el.field == fieldName);
			if (indexToRemove > -1) {
				state.paramsForFilter.attributes.splice(indexToRemove, 1);
			}
		}
	},
	resetParam(state) {
		state.paramsForFilter.attributes = [];
	},
	/* FILTER MUTATIONS END */

	newContragent(state, addedUser) {
		state.newContragent = addedUser;
	},
	setSaldoMoneyTransferResponse(state, data) {
		state.newMoneyTransfer = data;
	},
	setSaldoByYear(state, data) {
		state.saldoByYear = data;
	},
	createContragentError(state, payload) {
		state.createError = payload.boolean;
		state.createContragentErrorMessage = payload.message;
	},
	createMoneyTransferError(state, payload) {
		state.moneyTransferError = payload.boolean;
		state.moneyTransferErrorMessage = payload.message;
	},
	setSaldoByYearError(state, payload) {
		state.saldoByYearError = payload.boolean;
		state.saldoByYearErrorMessage = payload.message;
	},
	deleteContragent(state, obj) {
		if (obj.deleteResponse) {
			let foundIndex = state.contragents.findIndex(x => x.id == obj.id);
			state.contragents.splice(foundIndex, 1);
			state.notAllowedError = false;
		}
	},
	deleteContragentError(state, payload) {
		state.notAllowedError = payload.boolean;
		state.deleteContragentErrorMessage = payload.message;
	}
};

export const contragents = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
